import { ApiUrl } from '@common/enums';
import { CustomSideModel } from '@common/models/predefined-custom-side.model';

import { staticContentService } from '../staticContentService';

const customSidesApi = staticContentService.injectEndpoints({
    endpoints: (builder) => ({
        fetchCustomSides: builder.query<CustomSideModel[], void>({
            query: () => ({
                url: ApiUrl.CUSTOM_SIDES,
                method: 'GET',
            }),
        }),
    }),
});

export const { useFetchCustomSidesQuery } = customSidesApi;
